import styled, { css } from 'styled-components';
import theme from '../../../assets/styles/theme';

export const Header = styled.div`
  display: flex;

  ${({ align }) => {
    let aligns = {
      left: 'flex-start',
      right: 'flex-end',
      center: 'center',
    };

    return css`
      justify-content: ${aligns[align]};
    `;
  }}
`;

export const IconWrapper = styled.div`
  margin-left: ${theme.spacing['spacing-3']};
`;
